//促销优惠
const PromotionalDiscounts= () => import(/*webpackChunkName:'sale'*/"@/page/promotional-discounts/promotional-discounts.vue")

//商户分类
const MerchantClass= () => import(/*webpackChunkName:'sale'*/"@/page/promotional-discounts/merchant-class.vue")

const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')

export  const promotionalDiscounts=
    {
        path: '/main/promotional-discounts',
        name: '促销优惠',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/promotional-discounts/merchant-class',
            name: '商户分类',
            meta: {
                requireAuth: true,
            },
            component: MerchantClass
        },
        {
            path: '/main/promotional-discounts/merchant',
            name: '商户管理',
            meta: {
                requireAuth: true,
            },
            component: PromotionalDiscounts
        },
    ]
    }